import { get, post } from "@utils/httpUtil";
// 获取所有系统菜单
export function allSysMenu(data, config) {
  return get(`/sysmenu/v2/allSysMenu`, data, config);
}
// 分页查询社区成员
export function getComtyAccountList(data, config) {
  return post(`/v2/account/pageAccount`, data, config);
}
// 查询当前社区的角色
export function findCommunityRole(data, config) {
  return get(`/v2/account/findCommunityRole`, data, config);
}
// 查询当前社区用户的角色列表
export function getComtyRoleList(data, config) {
  return post(`/v2/role/pageRole`, data, config);
}
// 当前社区新增角色
export function newComtyAddRole(data, config) {
  return post(`/v2/role/addRole`, data, config);
}
// 当前社区更新角色
export function newComtyUpdateRole(data, config) {
  return post(`/v2/role/updateRole`, data, config);
}
// 查询角色和菜单信息
export function newComtygetRoleAndMenu(data, config) {
  return get(`/v2/role/getRoleAndMenu`, data, config);
}
// 确认社区角色名称是否有效
export function checkRoleNameAvailable(data, config) {
  return post(`/v2/role/checkRoleNameAvailable`, data, config);
}
// 社区删除角色
export function newComtyDeleteRole(data, config) {
  return get(`/v2/role/deleteRole`, data, config);
}
// 添加成员
export function newComtyAddAccount(data, config) {
  return post(`/v2/account/addAccount`, data, config);
}
// 编辑成员
export function newComtyUpdateAccount(data, config) {
  return post(`/v2/account/updateAccount`, data, config);
}
// 删除成员
export function newComtyDeleteAccount(data, config) {
  return get(`/v2/account/deleteAccount`, data, config);
}
// 批量删除成员
export function newComtyBatchDeleteAccount(data, config) {
  return post(`/v2/account/batchDeleteAccount`, data, config);
}
// 停用成员
export function newComtyInvalidAccount(data, config) {
  return get(`/v2/account/invalidAccount`, data, config);
}
// 启用成员
export function newComtyValidAccount(data, config) {
  return get(`/v2/account/validAccount`, data, config);
}